<template>
    <div class="bg-dark text-light " style="min-height:100vh">
        <div class="d-flex justify-content-center align-items-around" style="height:100vh">
           
            <div class="col-sm-12 col-md-8 col-lg-10">
           <div class="row justify-content-center">  <div class=" p-4" 
                            style="font-family:vazir;font-size:24pt;font-weight:600;color:cyan">رایـ<span style="color:whitesmoke">مو</span></div></div>     
                <div class="input-group">
                <div class="input-group-prepend"><i class="fas fa-search pr-3 pl-3 input-group-text p-1" style="color:gray;background:transparent"></i></div>
                <input type="text" class="form-control"
                placeholder="کلمه مورد نظر را وارد کنید"
                v-model="search"
                 name="" id="">
                   
                 <div class="sug bg-dark animated fadeIn " v-if="showSug" style="min-height:100px">
                     <div class="mt-3 container">
                         <div v-if="Array.isArray(suggest) && suggest.length != 0">
                            <router-link v-for="s in suggest" :key="s.index" style="cursor:pointer" :to="`/getWordRhyme/${s.id}`">
                             {{s.fullWord}}
                             <small style="float:left;color:gray" class="mt-2">{{$persianDigits(s.hejaCounter)}} هجا</small>
                             <p><small  v-for="a in s.ava" :key="a.index" style="color:gray">/ {{a}}  </small></p>
                             
                             <hr>
                         </router-link>
                         </div>
                         <div v-else>
                              <b-spinner style="position:absolute;right:45%;top:35%" v-if="status == 'waiting'" variant="primary" type="grow" label="Spinning"></b-spinner>
                              <div v-else style="text-align:center">
                                  <p>این کلمه پیدا نشد ، این کلمه رو اضافه کن رایمو برات قافیه هاشو پیدا میکنه</p>
                                  <router-link :to="`/addWord?string=${search}`" class="btn btn-info"><i class="fas fa-plus"></i></router-link>
                              </div>
                         </div>
                     </div>
                 </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            showSug: false,
            suggest:[],
            search:'',
            status : 'none'
        }
    },
    watch:{
        async search(){
            if(this.search.length > 2){
                this.status = 'waiting'
                this.showSug = true
                let res = await axios.get(`http://185.81.96.220/suggestWord?api_token=${this.$store.getters.token}&string=${this.search}`)  
                if(res.status == 200){
                    this.status = 'success'
                    this.suggest = res.data
                }else{
                    this.status = 'failed'
                }
            }
        }
    }
}
</script>
<style scoped>
.sug{
 position: absolute;
 margin-top: 45px;
 width: 100%;
 background:white;
 border-bottom-left-radius: 10px;
 border-bottom-right-radius: 10px;
 border:1px white solid
}
</style>